export const DEFAULT_DISABLED_VALUE = false;
export const DEFAULT_SELECTS_RANGE_VALUE = true;
export const DEFAULT_REQUIRED_VALUE = false;
export const DEFAULT_BLOCK_PAST_DATES = false;
export const REQUIRED_MARK_ARIA_LABEL = 'Required';
export const REQUIRED_MARK = ' *';
export const SINGLE_MONTH = 1;
